import { AutoComplete } from "@fidget/common/components/form/autoComplete/autoComplete";
import { ControllerStateAndHelpers } from "downshift";
import React, { useState } from "react";
import { SearchingInput } from "./searchingInput";
import inputStyles from "./searchingInput.css";

export interface Props<T> {
  itemProvider: (helpers: ControllerStateAndHelpers<T>) => T[];
  onChange: (item: T) => void;
  mapItemToString: (item: T | null) => string;
  placeholder: string;
  notFoundText: string;
  withIcon?: boolean;
  itemClassName?: string;
  isOpen?: boolean;
}

export const AutoCompleteSearchingInput = <T extends {}>(props: Props<T>) => {
  const {
    itemProvider,
    onChange,
    mapItemToString,
    placeholder,
    notFoundText,
    withIcon = false,
    itemClassName,
    isOpen
  } = props;
  const [input, setInput] = useState<string>();

  const renderQueryInput = (helpers: ControllerStateAndHelpers<T>) => (
    <SearchingInput
      value={helpers.inputValue || ""}
      onChange={setInput}
      placeholder={placeholder}
      withIcon={withIcon}
      inputProps={helpers.getInputProps()}
      autoFocus
    />
  );

  const render = () => (
    <AutoComplete<T>
      className={inputStyles.input}
      itemsProvider={itemProvider}
      onChange={(item) => onChange(item as T)}
      itemToString={mapItemToString}
      inputValue={input}
      autoFocus
      emptyPlaceholder={notFoundText}
      renderQueryInput={renderQueryInput}
      initialIsOpen
      isOpen={isOpen}
      itemClassName={itemClassName}
      initialHighlightedIndex={0}
    />
  );

  return render();
};
